export default __webpack_public_path__ + "static/media/Coffee-Gable-Coffee-Discovery-5.28932a64.jpg";